export default __webpack_public_path__ + "static/problemlöser-f525f51a105d18255249d04e1bc281c4.svg";